import { useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { resolveVseImages } from '@/lib/vse-image-access';

/** Covers engine PNGs embedded in rich HTML, options, passages and reviews alike. */
export function VseImageAccess() {
  useEffect(() => resolveVseImages(document.body, async path => {
    const { data, error } = await supabase.storage.from('vicsel-exam-images').createSignedUrl(path, 3600);
    if (error || !data?.signedUrl) throw error ?? new Error('Image unavailable');
    return data.signedUrl;
  }), []);
  return null;
}
